import ModalSkateOrderGuidance from "./ModalSkateOrderGuidance";
export default ModalSkateOrderGuidance;
